import { ChangeDetectionStrategy, Component, inject, ViewChild } from '@angular/core';

import { DropdownHeaderComponent } from '../../../../common/dropdown/dropdown-header/dropdown-header.component';
import { Select2HeaderDirective } from './header.directive';

@Component({
  selector: 'rt-select-header',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Select2HeaderDirective, DropdownHeaderComponent],
  template: `
    <ng-template rtSelectHeader>
      <rt-dropdown-header>
        <ng-container ngProjectAs="[prefix]">
          <ng-content select="[prefix]"></ng-content>
        </ng-container>
        <ng-content></ng-content>
        <ng-container ngProjectAs="[suffix]">
          <ng-content select="[suffix]"></ng-content>
        </ng-container>
      </rt-dropdown-header>
    </ng-template>
  `,
  providers: [
    {
      provide: Select2HeaderDirective,
      useFactory: () => inject(HeaderDefaultComponent).directive,
    },
  ],
})
export class HeaderDefaultComponent {
  @ViewChild(Select2HeaderDirective, { static: true })
  public directive: Select2HeaderDirective;
}
